export default function getQueryParam(input: string): string | null {
	const params = new URL(String(document.location)).searchParams;
	return params.get(input);
}
